import React, { useEffect, useState } from "react";
import { Button, Table2, Alert } from "components";
import { Edit, Trash } from "../../../../../../layouts/dashboard/sidebar/icons/icons/icons";
import config from "constants/config";
import useTheme from "../../../../../../../../hooks/useTheme";
import GenerateSerials from "../generate-serials";

import "../modals.scss";
import "./index.scss";



const VARIANT_FIELDS = {
	title: '',
	price: '',
	description: '',
	serials: '',
	license_period: '',
}

export const VariantTable = ({ data, isLicense, edit, remove, currency, skipButtons }) => {

	if(skipButtons && !data.length) {
		return null
	}

	let columns = [{
		accessor: 'title',
		Header: 'Title'
	}, {
		accessor: 'price',
		Header: 'Price',
		Cell: ({ row }) => <span>{row.original.price}{config.CURRENCY_LIST[currency]}</span>,
	}, {
		accessor: 'description',
		Header: 'Description'
	}, {
		accessor: 'options',
		Header: '',
		disableSortBy: true,
		Cell: ({ row }) => (
			<div className="widget-table-options">
				<Button onClick={() => edit(row.index)} size="large" square variant="secondary" className="mr-3">
					<Edit />
				</Button>
				<Button onClick={() => remove(row.index)} size="large" square variant="warning">
					<Trash />
				</Button>
			</div>
		)
	}];

	if(isLicense) {
		columns.splice(3, 0, {
			accessor: 'license_period',
			Header: 'License'
		});
	}


	if(skipButtons) {
		columns.pop()
	}

	if(!data.length) {
		return null
	}

	return <div className="widget-modal-table">
		<Table2 data={data} columns={columns} notFound="No Variants" />
	</div>
};


const VariantForm = ({ setDelimiter, form, isSerials, isLicense, data, setData, cancel, update, currency, active }) => {

	if(!active) {
		return null;
	}

	let disabled = !data.title || !data.price;

	if(isLicense) {
		disabled = !data.title || !data.price || !data.license_period;
	}

	return <div className="custom-widget">

		<div className="custom-widget-body variant-form">

			<div className="w-70 pr-3">
				<label className="paylixecommerce-label" htmlFor="title" >Variant Name</label>
				<input className="paylixecommerce-input" type="text" value={data.title} onChange={(e) => setData({
					...data,
					title: e.target.value
				})} placeholder="Product Name" />
			</div>

			<div className="w-30 variant-form-price">
				<div className="variant-form-price-currency">
					{config.CURRENCY_LIST[currency]}
				</div>
				<div className="">
					<label className="paylixecommerce-label" htmlFor="price">Price</label>
					<input className="paylixecommerce-input" type="number" value={data.price} onChange={(e) => setData({
						...data,
						price: e.target.value
					})} placeholder="10" />
				</div>
			</div>

			{+data.price === 5 && form.values.currency === "USD" ?
				<Alert className="w-100 mt-3 mb-0" purple title="Info" text="By setting your product price to USD 4.99 instead, you'll avoid our 0.25 fee." /> : null
			}

			<div className="w-100 mt-4">
				<label className="paylixecommerce-label" htmlFor="textarea" >Short Description</label>
				<textarea className="paylixecommerce-input textarea" value={data.description} onChange={(e) => setData({
					...data,
					description: e.target.value
				})} placeholder="Variant product text" />
			</div>

			{
				isSerials ?
					<div className="w-100 mt-4">
						<label className="paylixecommerce-label" htmlFor="name" >Serials List</label>
						<textarea className="paylixecommerce-input textarea" value={data.serials} onChange={(e) => setData({
							...data,
							serials: e.target.value
						})} placeholder="1,2,3,4..." />
					</div>
					: null
			}

			{isSerials && isLicense &&
				<GenerateSerials isVariant setVariant={(serials) => {
					setData({
						...data,
						serials
					})
				}} setDelimiter={setDelimiter} form={form} />
			}


			{isSerials && isLicense &&
				<div className="w-100 mt-4 position-relative">
					<label className="paylixecommerce-label" htmlFor="title" >License Expiration</label>
					<input className="paylixecommerce-input" type="number" value={data.license_period} onChange={(e) => setData({
						...data,
						license_period: e.target.value
					})} placeholder="365" />
					<div className="discount-currency" style={{ right: 0, borderLeft: "1px solid var(--black0)", fontSize: 14, fontWeight: 400 }}>
						Days
					</div>
				</div>
			}

			{isSerials && isLicense &&
				<Alert
					className="mt-3"
					title="Editing license period"
					text="When you edit the license period, this will affect every ongoing license. Renewals will be using this period and it will be updated everywhere in your dashboard."
					red
					show={true}
				/>
			}

		</div>

		<div className="custom-widget-footer">
			<Button className="mr-3" size="large" variant="secondary" onClick={cancel}>
				Cancel
			</Button>
			<Button onClick={update} size="large" disabled={disabled ? "disabled" : ""}>
				Save
			</Button>
		</div>

	</div>
}

export default ({ form, setDelimiter, fields, updateFields, setModal, modal, currency, isLicense, isSerials }) => {

	const [currentIndex, setCurrentIndex] = useState(null);
	const [data, setData] = useState({});
	const isDark = useTheme();

	useEffect(() => {
		if(currentIndex === 0 || currentIndex) {
			let field = fields[currentIndex] ? fields[currentIndex] : VARIANT_FIELDS;

			if(isSerials) {
				if(isLicense) {
					setData({
						price: field.price,
						title: field.title,
						description: field.description,
						serials: field.serials,
						license_period: field.license_period,
					});
				} else {
					setData({
						price: field.price,
						title: field.title,
						description: field.description,
						serials: field.serials,
					});
				}
			} else {
				setData({
					price: field.price,
					title: field.title,
					description: field.description
				});
			}
		}
	}, [currentIndex, isSerials]);


	const addField = (index) => {
		setCurrentIndex(index ? index : true);
	};

	const updateField = () => {

		if(fields[currentIndex]) {
			fields[currentIndex] = data;
			updateFields([
				...fields
			]);
		} else {
			updateFields([
				...fields,
				data
			]);
		}

		setCurrentIndex(null);
		setModal(null);
	}

	const cancelEdit = () => {
		setCurrentIndex(null);
		setModal(null);
	}

	const editField = (index) => {
		setCurrentIndex(index);
		setModal(fields[index]);
	}

	const removeField = (index) => {

		if(fields[index]) {

			let updated = Object.assign([], fields);
			updated.splice(index, 1);
			updateFields([
				...updated
			]);

		}

		setCurrentIndex(null);
	}

	const active = (currentIndex === 0 || currentIndex);

	if(form.values.type === "SUBSCRIPTION") {
		return null
	}


	return <div className="widget-modal">

		<VariantTable isLicense={isLicense} data={fields} edit={editField} remove={removeField} currency={currency} />

		{modal ?
			<VariantForm setDelimiter={setDelimiter} form={form} isSerials={isSerials} isLicense={isLicense} update={updateField} cancel={cancelEdit} currency={currency} setData={setData} active={modal} data={data}/> :
			<Button className="w-100" size="large" variant={isDark ? "primary" : "secondary"} iconName="plus" iconPosition="left" onClick={() => setModal(true)}>Configure Variant</Button>
		}

	</div>
}
